import { render, staticRenderFns } from "./FundingPage.vue?vue&type=template&id=6060aee4"
import script from "./FundingPage.vue?vue&type=script&lang=ts"
export * from "./FundingPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports